import React from "react";

import { useModalContext } from "../../contexts/ModalContext/context";
import { Box } from "../../UI/Box";
import { Button } from "../../UI/Button";
import { Typography } from "../../UI/Typography";
import { Modal } from "../Modal";

interface IProps {
  handleConfirm: VoidFunction;
}

export const RecordChangeConfirmModal: React.FC<IProps> = (props) => {
  const { setIsOpen } = useModalContext();

  const onHide = () => {
    setIsOpen(false);
  };

  return (
    <Modal
      title="Are you sure?"
      actions={
        <>
          <Button appearance="subtle" onClick={props.handleConfirm}>
            Yes Make this Change
          </Button>
          <Button appearance="primary" onClick={onHide}>
            No, Cancel this Change
          </Button>
        </>
      }
    >
      <Box px={3} py={2}>
        <Typography variant="body2" gutterBottom>
          There are users currently in this subnetwork. If users already selected the housing being modified, user
          selections will update to the new language. We recommend only modifying selections for typographical reasons.
        </Typography>
        <Typography variant="body2" gutterBottom>
          Would you still like to make this update?
        </Typography>
      </Box>
    </Modal>
  );
};
